/**
 * Node modules
 */
import styled from 'styled-components';

/**
 * Styled components
 */
export default styled.span`
  font-size: 70%;
  font-style: italic;
`;
